import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, obj = user
  const [selectedClient, setSelectedClient] = useState("all");

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      // Don't downgrade an already-authenticated user: the initial anonymous
      // /me check can resolve AFTER a fast login and must not clobber it.
      setUser((prev) => (prev ? prev : false));
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setUser(false);
  };

  const isSuper = user && user.role === "super_admin";

  return (
    <AuthCtx.Provider value={{ user, login, logout, refresh, isSuper, selectedClient, setSelectedClient }}>
      {children}
    </AuthCtx.Provider>
  );
}
